import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import type {
  TComboboxEmptyElement,
  TComboboxEmptyProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const ComboboxEmpty = forwardRef<TComboboxEmptyElement, TComboboxEmptyProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive.Empty
      data-component="ComboboxEmpty"
      ref={ref}
      className={cn("py-6 text-center", className)}
      {...props}
    >
      <TextBody tag="span" size={2} isResponsive={false}>
        { children }
      </TextBody>
    </CommandPrimitive.Empty>
  ),
);

ComboboxEmpty.displayName = CommandPrimitive.Empty.displayName;
